/* eslint-disable max-classes-per-file */
import type { ResponseInterface } from "@/libs/server/goApiServer/common/commonInterface";

export interface RequestEventAllocateInterface {
  contactTitle: string;
  contactFirstname: string;
  contactLastname: string;
  contactEmail: string;
  contactPhone: string;
}

export interface RequestAllocateInterface {
  contactTitle: string;
  contactFirstname: string;
  contactLastname: string;
  contactEmail: string;
  contactPhone: string;
  contactPrefixPhone: string;
  countryOfPassport?: string;
  contactIssuePassport?: string;
  contactNationality?: string;
  passportNumber?: string;
  date: string;
  key: string;
  guest?: {
    titlename: string;
    firstname: string;
    lastname: string;
    countryOfPassport: string;
    passportNumber: string;
    nationality: string;
  }[];
  bookingInfo?: {
    bookingDate: string;
    returnDate?: string;
    passportNumber: string;
    medicalCondition: string;
  };
  [key: string]: number | string | undefined | any;
  requiredFields?: {
    fields?: {
      key: string;
      value: string;
    }[];
  }[];
  ttclid?: string;
  _ttp?: string;
  _fbc?: string;
  _fbp?: string;
  ga4Data?: string;
}

export interface AllocateTicketInterface {
  ticket_id: string;
  ticket_category_id: any;
  ticket_supplier_id: string;
  wholesale_id: any;
  ticket_wholesale_ticket_id: string;
  klub_category_id: any;
  ticket_name: string;
  ticket_description: string;
  ticket_description_details: any;
  address: string;
  area_id: any;
  area_name: string;
  area_slug: string;
  city_id: string;
  city_name: string;
  city_slug: string;
  country_id: string;
  country_name: string;
  country_slug: string;
  ticket_slug: string;
  term_condition: any;
  cancellation_policy: any;
  latitude: any;
  longitude: any;
  mobile_number: string;
  tier: string;
  ticket_type: string;
  time_duration: string;
  available_language: string;
  transportation_detail: any;
  experience_detail: any;
  preparation_detail: any;
  price_condition: any;
  ticket_include: any;
  photo_cover_path: string;
}

export interface ResponseExperienceAllocateInterface {
  bookingInternalNo: string;
  rsvnId: number;
  ticketDate: string;
  currency: string;
  totalPrice: number;
  totalAmount: number;
  tickets: AllocateTicketInterface;
  totalQuantity: string;
  paymentUrl: string;
}

export class ResponseExperienceAllocate {
  bookingInternalNo: string;

  rsvnId: number;

  ticketDate: string;

  currency: string;

  totalPrice: number;

  totalAmount: number;

  tickets: AllocateTicketInterface;

  totalQuantity: string;

  paymentUrl: string;

  constructor(data: ResponseExperienceAllocateInterface) {
    this.ticketDate = data?.ticketDate || "";
    this.bookingInternalNo = data?.bookingInternalNo || "";
    this.rsvnId = data?.rsvnId || 0;
    this.currency = data?.currency || "";
    this.totalPrice = data?.totalPrice || 0;
    this.totalAmount = data?.totalAmount || 0;
    this.tickets = data?.tickets || [];
    this.totalQuantity = data?.totalQuantity;
    this.paymentUrl = data?.paymentUrl || "";
  }
}

export class ResponseAllocate {
  status: boolean;

  message: string;

  data: ResponseExperienceAllocateInterface;

  constructor(
    response: ResponseInterface<ResponseExperienceAllocateInterface>,
  ) {
    this.status = response.status || false;
    this.message = response.message || "";
    this.data = new ResponseExperienceAllocate(response?.data);
  }
}
